<template>
  <div id="sequence_analytics_grid">
    <InfoGrid :columns="3">
      <ContainerInfoItem
        v-for="(data, key) in analyticsData"
        :key="key"
        source="sequence_analytics_grid"
        :title="data.title"
        :description="range?.label || ''"
        :value="formatAnalyticsValue(data.value, data.unit)"
        :is-loading="data.isLoading"
      />
    </InfoGrid>
  </div>
</template>

<script setup>
import { computed, reactive, watch } from "vue";
import { formatAnalyticsValue } from "@/src/utils/analyticUtils.js";
import store from "@/src/store/index.js";
import InfoGrid from "@/src/components/info_components/InfoGrid.vue";
import ContainerInfoItem from "@/src/components/info_components/ContainerInfoItem.vue";
import AnalyticService from "@/src/api/AnalyticService.js";
import { sequenceActions } from "@/src/constants/analyticConstants.js";
import { useAnalyticsRefresh } from "@/src/composables/useAnalyticsRefresh.js";

const range = computed(() => store.getters["analytics/getRange"]);
const filters = computed(() => store.getters["analytics/getFilters"]);
const userIds = computed(() => store.getters["analytics/getUserIds"]);
const teamIds = computed(() => store.getters["analytics/getTeamIds"]);

const analyticsData = reactive([
  {
    id: sequenceActions.TOTAL_PEOPLE,
    title: "Total people",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceActions.TOTAL_CONTACTS,
    title: "Total contacts",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceActions.TOTAL_LEADS,
    title: "Total leads",
    value: 0,
    isLoading: false,
  },
]);

const fetchAnalytics = async () => {
  analyticsData.forEach((item) => {
    item.isLoading = true;
  });

  try {
    const params = {
      user_id: userIds.value,
      team_id: teamIds.value,
      start_time: range.value?.start,
      end_time: range.value?.end,
      sequence_id: filters.value?.sequence?.id,
    };

    AnalyticService.V2.fetchSequencePeopleCount(params).then((response) => {
      if (response?.success) {
        const data = response?.data?.results;
        analyticsData.forEach((item) => {
          if (data[item.id] !== undefined) {
            item.value = data[item.id];
          }
        });
      }
    });

  } catch (error) {
    console.error("An error occurred while fetching analytics: ", error);
  } finally {
    analyticsData.forEach((item) => {
      item.isLoading = false;
    });
  }
};

watch([range, filters, userIds, teamIds], () => {
  console.log('Watch triggered:', {
    range: range.value,
    filters: filters.value,
    sequenceId: filters.value?.sequence?.id,
    userIds: userIds.value,
    teamIds: teamIds.value
  });
  
  if (range?.value || filters.value?.sequence?.id) {
    fetchAnalytics();
  } else {
    console.log('No sequence ID found in filters');
  }
}, { deep: true, immediate: true });

useAnalyticsRefresh(fetchAnalytics, [range, userIds, teamIds]);
</script>
